import { Component, OnInit } from "@angular/core";
import { PRODUCTS, Product } from "../../models/product";
import { CartItem } from "../../models/cart-item";
import { CartService } from "../../services/cart.service";
import { ProductService } from "../../services/product.service";
import { Router } from "@angular/router";
import { Quantity } from "../../models/quantity";
import { BrandService } from "../../services/brand.service";
import { Brand } from "../../models/brand";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  allBrands: Brand[] = new Array();
  cartNumber: number = 0;
  products = PRODUCTS;
  categories: string[] = new Array();
  mushrooms: string[] = new Array();
  brands: string[] = new Array();
  strains: Product[] = new Array();
  searchString = "";
  cartItems: CartItem[] = new Array();
  total: number = 0;

  constructor(
    private cartService: CartService,
    private productService: ProductService,
    private router: Router,
    private brandService: BrandService
  ) {}

  ngOnInit() {
    this.cartService.getCartNumber().subscribe((data) => {
      this.cartNumber = data;
      this.total = this.cartService.total();
    });
    this.cartService.getItems().subscribe((data) => {
      this.cartItems = data;
    });
    // this.allBrands = this.brandService.getBrands()
    this.setCategories();
    this.setStrains();
    this.setBrands();
    this.setMushrooms();
  }

  printQuantity(item: CartItem) {
    let quantities = item.quantities;
    let all: string = "";
    for (var i = 0; i < quantities.length; i++) {
      if (i == 0) all = quantities[i].quantity + " - " + quantities[i].unit;
      else
        all = all + " & " + quantities[i].quantity + " - " + quantities[i].unit;
    }
    return all;
  }

  cartTotal() {
    return this.cartService.total();
  }

  itemTotal(item: CartItem): number {
    let prices = item.product.prices;
    let map: Map<string, number> = new Map<string, number>();
    for (var i = 0; i < prices.length; i++) {
      map.set(prices[i].unit, prices[i].amount);
    }
    let total = 0;
    item.quantities.forEach((quantity: Quantity) => {
      total += map.get(quantity.unit) * quantity.quantity;
    });
    return total;
  }

  search() {
    if (this.searchString !== "") {
      this.router.navigate(["search/" + this.searchString.replace(" ", "+")]);
    }
  }

  delete(item: CartItem) {
    this.cartItems = this.cartService.remove(item);
  }

  getCategoryArray(category: string): Product[] {
    return this.productService.findByCategory(category);
  }

  getCartegoryArray(category: string): Product[] {
    return this.productService.findByCategory(category);
  }

  setCategories() {
    this.productService.findAll().forEach((p) => {
      if (
        !this.categories.includes(p.category.toLowerCase()) &&
        p.category != ""
      ) {
        this.categories.push(p.category.toLowerCase());
      }
    });
  }

  setMushrooms() {
    this.productService.findAll().forEach((p) => {
      if (
        p.category == "Mushrooms Capsules" ||
        p.category == "Mushrooms Tea" ||
        p.category == "Dried Mushrooms" ||
        p.category == "Mushrooms Edibles"
      ) {
        if (!this.mushrooms.includes(p.category.toLocaleLowerCase())) {
          this.mushrooms.push(p.category.toLocaleLowerCase());
        }
      }
    });
  }

  setStrains() {
    this.products.forEach((p) => {
      if (p.category === "Strain") {
        this.strains.push(p);
      }
    });
  }

  setBrands() {
    this.brandService.getBrands().forEach((p) => {
      if (p.name != "recreational hemps") {
        this.allBrands.push(p);
      }
    });
  }
}
